import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { AuthPartialState } from './auth.reducer';
import { authQuery } from './auth.selectors';
import { LoadAuth, LogOut, SignIn, SignUp } from './auth.actions';

@Injectable()
export class AuthFacade {
  loaded$ = this.store.pipe(select(authQuery.getLoaded));
  allAuth$ = this.store.pipe(select(authQuery.getAllAuth));
  selectedAuth$ = this.store.pipe(select(authQuery.getSelectedAuth));
  loading$ = this.store.pipe(select(authQuery.getLoading));
  error$ = this.store.pipe(select(authQuery.getError));
  user$ = this.store.pipe(select(authQuery.getUser));
  constructor(private store: Store<AuthPartialState>) {}

  loadAll() {
    this.store.dispatch(new LoadAuth());
  }
  signIn(username: string, password: string) {
    this.store.dispatch(new SignIn({ username, password }));
  }
  signUp(username: string, password: string, email: string, role: string) {
    this.store.dispatch(new SignUp({ username, password, email, role }));
  }
  logOut() {
    this.store.dispatch(new LogOut());
  }
}
